__turbopack_context__.v({
  "cel": "weather-module-scss-module__n56TMq__cel",
  "celsiusactive": "weather-module-scss-module__n56TMq__celsiusactive",
  "container": "weather-module-scss-module__n56TMq__container",
  "date": "weather-module-scss-module__n56TMq__date",
  "description": "weather-module-scss-module__n56TMq__description",
  "fah": "weather-module-scss-module__n56TMq__fah",
  "fahrenheitactive": "weather-module-scss-module__n56TMq__fahrenheitactive",
  "icon": "weather-module-scss-module__n56TMq__icon",
  "temp": "weather-module-scss-module__n56TMq__temp",
  "tempnum": "weather-module-scss-module__n56TMq__tempnum",
});
